<div class="logo" [ngClass]="{'edit-photo': status==='edit'}">
    <!-- [ngClass]="{'edit-photo': status==='edit'}" -->
    <div hidden>
        <input type="file" accept="image/*" #logo (change)="onImageSelect('logo',$event)"  [disabled]="status !== 'edit'">
    </div>
    <img src="../../assets/images/login_back.jpg" alt="" (click)="logo.click()" *ngIf="!uploadingLogo && !previousUploadedLogoURL && !uploadedLogoURL">
    <img src="{{previousUploadedLogoURL}}" alt="" (click)="logo.click()" *ngIf="!uploadingLogo && previousUploadedLogoURL && !uploadedLogoURL">
    <img src="{{uploadedLogoURL}}" alt="" (click)="logo.click()" *ngIf="!uploadingLogo && uploadedLogoURL">
    <img src="../../assets/images/loading-spinner.gif" alt="" *ngIf="uploadingLogo" class="uploading-logo">
    <div class="p-m-2 p-d-flex p-jc-center">
        <!-- <b>{{(showClinicInput)? profileForm?.value?.fname + ' ( Logo )': 'Admin Logo'}}</b> -->
    </div>
</div>
<div class="photo" [ngClass]="{'edit-photo': status==='edit'}">
    <div hidden>
        <input type="file" accept="image/*" #profile (change)="onImageSelect('profile',$event)" [disabled]="status !== 'edit'">
    </div>
    <img src="../../assets/images/profile.png" alt="" (click)="profile.click()" *ngIf="!uploadingProfile && !previousUploadedPhotoURL && !uploadedPhotoURL">
    <img src="{{previousUploadedPhotoURL}}" alt="" (click)="profile.click()" *ngIf="!uploadingProfile && previousUploadedPhotoURL && !uploadedPhotoURL">
    <img src="{{uploadedPhotoURL}}" alt="" (click)="profile.click()" *ngIf="!uploadingProfile && uploadedPhotoURL ">
    <img src="../../assets/images/loading-spinner.gif" alt="" *ngIf="uploadingProfile">
    <div class="p-m-2 p-d-flex p-jc-center">
        <!-- <b>{{profileForm?.value?.fname+' '+profileForm?.value?.lname}} </b> -->
    </div>
</div>

<div class="p-m-2 p-d-flex p-flex-column">
    <div class="p-d-flex p-jc-center p-ai-center p-m-4">
        <!-- <button pButton class="p-button-primary p-button-rounded" label="Back" icon="pi pi-arrow-left" (click)="back()">
        </button> -->
        <!-- <h2>Profile</h2> -->
        <!-- <button pButton class="p-button-warning p-button-rounded" label="Edit" icon="pi pi-pencil" (click)="status='edit'">
        </button> -->
    </div>
    <div class="p-d-flex p-flex-column p-ai-center">
        <div class="p-d-flex p-flex-column photo-container">
            
            
        </div>
        <form [formGroup]="profileForm" class="form-container">
            <div class="p-m-6 ">
                <div class="p-field">
                    <label for="fname">First Name</label>
                    <input id="fname" type="text" pInputText formControlName="fname" [readonly]="status=='show'">
                </div>
                <div class="p-field">
                    <label for="lname">Last Name</label>
                    <input id="lname" type="text" pInputText formControlName="lname" [readonly]="status=='show'">
                </div>
                <div class="p-field" *ngIf="showClinicInput">
                    <label for="name">Clinic Name</label>
                    <input id="name" type="text" pInputText formControlName="name" [readonly]="status=='show'">
                </div>
                <div class="p-field">
                    <label for="email">Email</label>
                    <input id="email" type="text" pInputText formControlName="email" [readonly]="status=='show'">
                </div>
                <div class="p-field">
                    <label for="phone">Phone</label>
                    <input id="phone" type="text" pInputText formControlName="phone" [readonly]="status=='show'">
                </div>
            </div>
            <div class=" p-m-6">
                <div class="p-field">
                    <label for="desc">Description</label>
                    <textarea id="desc" type="text" pInputTextarea formControlName="desc" autoResize="autoResize" [rows]="4" [readonly]="status=='show'"></textarea>
                </div>
                <div class="p-field">
                    <label for="address">Address</label>
                    <textarea id="address" type="text" pInputTextarea formControlName="address" autoResize="autoResize" [rows]="4" [readonly]="status=='show'"></textarea>
                </div>
            </div>
            <div class=" p-m-6">
                <div class="p-field p-d-flex p-jc-between control-btn p-ml-2">
                    <button pButton class="p-button-primary" label="Back" icon="pi pi-arrow-left" (click)="back()"></button>
                    <button pButton *ngIf="status!=='show'" class="p-button-primary" label="Save" (click)="saveProfile()" ></button>
                    <button pButton *ngIf="status=='show'" class="p-button-warning" label="Edit" icon="pi pi-pencil" (click)="status='edit'"></button>
                </div>
            </div>
        </form>
    </div>
    
</div>